var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcNavRights(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_102_4446"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 0
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8199999928474426
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_102_4446)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.16667,14.29167L21.16667,12.91667C21.16667,10.9,19.51667,9.25,17.5,9.25C15.48333,9.25,13.83333,10.9,13.83333,12.91667L13.83333,14.29167C12.733334,14.93333,12,16.125,12,17.5L12,19.3333C12,21.35,13.65,23,15.66667,23L19.33333,23C21.35,23,23,21.35,23,19.3333L23,17.5C23,16.125,22.2667,14.93333,21.16667,14.29167ZM17.5,19.7917C16.76667,19.7917,16.125,19.15,16.125,18.41667C16.125,17.683329999999998,16.76667,17.04167,17.5,17.04167C18.23333,17.04167,18.875,17.683329999999998,18.875,18.41667C18.875,19.15,18.23333,19.7917,17.5,19.7917ZM19.33333,13.83333L15.66667,13.83333L15.66667,12.91667C15.66667,11.90833,16.49167,11.08333,17.5,11.08333C18.50833,11.08333,19.33333,11.90833,19.33333,12.91667L19.33333,13.83333Z",
    fill: "#FFFFFF",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.33331298828125,
    cy: 6.5,
    rx: 5.5,
    ry: 5.5,
    fill: "#FFFFFF",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.16667,19.3333280859375C10.16667,20.7083280859375,10.71667,21.991668085937498,11.5417,22.9999980859375L1.916667,22.9999980859375C1.366667,22.9999980859375,1,22.633338085937503,1,22.083328085937502L1,21.4416680859375C1,17.6833280859375,3.75,14.2916650859375,7.50833,13.9249992859375C8.425,13.8333321859375,9.25,13.9249992859375,10.075,14.1083320859375C10.625,14.1999990859375,10.9,14.8416660859375,10.625,15.3916680859375C10.35,16.033328085937498,10.16667,16.7666680859375,10.16667,17.4999980859375L10.16667,19.3333280859375Z",
    fill: "#DBE3E9",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.5,
    cy: 18.41668701171875,
    rx: 1.375,
    ry: 1.375,
    fill: "#333333",
    fillOpacity: 1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNavRights);
export default __webpack_public_path__ + "static/media/ic_nav_rights.8428f7e057ff6590be08e79eb50b0024.svg";
export { ForwardRef as ReactComponent };